<template>
    <v-card tile outlined elevation=2 class="mx-0 my-0 px-0 text-wrap" width="100%">
        <v-overlay v-if="disabling" :absolute="true" :value="true">
            <v-icon x-large color="red darken-2">
                not_interested
            </v-icon>

        </v-overlay>
        <div :class="[detail ? 'text-h6' : 'text-subtitle-1','ml-2', 'mt-1','mb-0', 'pr-2',
        detail ? 'font-weight-regular' : 'font-weight-bold' ]">
            <p v-if="detail" class="pl-2 ml-0 mb-1 mb-sm-2 blue--text text--darken-4 seminarColor"
                :style="{borderLeftColor:item.color}">
                {{item.name}}
            </p>
            <span v-else>
                <span v-if="preview" class="pl-1 py-0 mb-0 blue--text text--darken-4 seminarColor"
                    :style="{borderLeftColor:item.color}">
                    {{item.name}}
                </span>
                <router-link v-else :to="{name:bo?'seminar.bo':'seminar',params:{id:item.id}}"
                    class="pl-1 py-0 mb-0 blue--text text--darken-4 seminarColor" :style="{borderLeftColor:item.color}">
                    {{item.name}}
                </router-link>
            </span>
            <div v-if="item.category_event_specific">
                <p class="body-2 font-weight-regular pt-0 my-0">
                    <span v-if="detail" class="pr-1">usually takes place </span>
                    <span
                        :class="{'font-weight-bold':detail}">{{item.category_event_specific.usualy_date_seminar}}</span>
                </p>
                <p class=" body-2 font-weight-regular ml-0 my-0  pt-1  grey--text text--darken-2"
                    v-html="item.category_event_specific.usualy_place_seminar">
                </p>
                <p class="body-2 font-weight-bold ml-0 mt-1 mb-0 pb-0 ">
                    <span v-html="item.category_event_specific.chairmen"></span>
                </p>
                <div v-if="detail" v-html="item.category_event_specific.text"
                    class="body-2 font-weight-regular ml-0 mr-1 my-0 pt-2 pb-1  justify">
                </div>
            </div>
        </div>
        <div v-if="bo">
            <v-btn x-small class="mt-0 ml-2 white--text" color="blue darken-4"
                :to="{name:'seminar.program.addto.bo',params:{id:item.id}}">
                add talk to seminar
            </v-btn>
            <v-btn x-small class="mt-0 ml-2 white--text" color="green darken-4"
                :to="{name:'seminar.edit.bo',params:{id:item.id}}">
                edit seminar
            </v-btn>
            <item-mutate :mutation="'disable'" :type="'seminar'" :disabled="false" :item="item"
                :mutationEndpoint="'/index.php/api/calendar/categories/disable/'" @onMutateSuccess="onDisableSuccess"
                @onMutateRequest="onDisableRequest" @onMutateFailed="onDisableFinish" @onMutateFinish="onDisableFinish">
            </item-mutate>
        </div>
        <app-select-year-seminars v-if="detail" class="ml-1 pr-2 mt-2 mb-n2"></app-select-year-seminars>
    </v-card>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import selectYearSeminars from './SelectYearSeminars.vue';
import ItemMutate from '../../sharing/ItemMutate.vue';

export default {
    props: {
        item: {
            type: Object,

        },
        detail: {
            type: Boolean,
            default: false,
        },
        preview: {
            type: Boolean,
            default: false,
        },
        bo: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            disabling: false,
        }
    },
    computed: {
        ...mapGetters('talks', {
            category_id: 'category_id',
        }),
        ...mapGetters('seminars', ['getSeminar',])
    },
    methods: {
        ...mapMutations('seminars', ['DELETE_SEMINAR',]),
        onDisableSuccess() {
            this.DELETE_SEMINAR(this.item.id);
            // In case we delete on the seminar's dedicated page,
            // the seminar won't disappear so we keep it overlayed
            // a an indicator that it is not there.
            this.disabling = true;
        },
        onDisableRequest() {
            this.disabling = true;
        },
        onDisableFinish() {
            if(this.getSeminar(this.item.id)) {
                this.disabling = false;
            }
        },
    },
    components: {
        AppSelectYearSeminars: selectYearSeminars, ItemMutate
    },
}
</script>
<style scoped>
.justify {
    text-align: justify;
    text-justify: inter-word;
}

.date {
    border-left-color: orange;
    border-left-width: 2pt;
    border-left-style: groove;
}

.seminarColor {
    border-left-width: 8pt;
    border-left-style: solid;
}
</style>
